// import { Player } from "@lottiefiles/react-lottie-player";
import { Box, Slide } from "@mui/material";
import React, { forwardRef } from "react";
import ShakeEffect from "../../shakeEffect/ShakeEffect";
import FormFolioDeVenta from "./components/FormFolioDeVenta";

const FolioDeVenta = forwardRef(function FolioDeVenta(
  { nextStep, showToast, hidden, ...props },
  ref
) {
  return (
    <ShakeEffect>
      {(setIsError) => (
        <div hidden={hidden}>
          <Slide direction="left" in={!hidden} timeout={200}>
            <Box
              component="form"
              // noValidate
              autoComplete="off"
              sx={{
                display: "flex",
                justifyContent: "end",
                p: 1,
              }}
            >
              <FormFolioDeVenta
                ref={ref}
                setIsError={setIsError}
                nextStep={nextStep}
                showToast={showToast}
                setDatosCompra={props.setDatosCompra}
                {...props}
              />
            </Box>
          </Slide>
        </div>
      )}
    </ShakeEffect>
  );
});

export default FolioDeVenta;
